import { getOwaUnitCode, pad0 } from 'utils';
import { GraphAxis } from 'console/tabs/graphs/components/graph/utils/axis-base';
import { nnbsp } from 'console/utils/chars';
const rumbs = {
    0: '↑C',
    1: '↑ССВ',
    2: '↗СВ',
    3: '→ВСВ',
    4: '→В',
    5: '→ВЮВ',
    6: '↘ЮВ',
    7: '↓ЮЮВ',
    8: '↓Ю',
    9: '↓ЮЮЗ',
    10: '↙ЮЗ',
    11: '←ЗЮЗ',
    12: '←З',
    13: '←ЗСЗ',
    14: '↖СЗ',
    15: '↑ССЗ',
};
export const owa_axes = {
    owa_dc_voltage: new (class extends GraphAxis {
        unit = () => '⎓вольт';
        options = () => ({ minTickSize: 0.1 });
        format_value_with_unit = (value) => `⎓${this.format_value(value)}${nnbsp}В`;
    })(),
    owa_ac_voltage: new (class extends GraphAxis {
        unit = () => '⏦вольт';
        options = () => ({ minTickSize: 0.1 });
        format_value_with_unit = (value) => `∼${this.format_value(value)}${nnbsp}В`;
    })(),
    owa_g_m3: new (class extends GraphAxis {
        unit = () => 'г/м³';
        options = () => ({ minTickSize: 1 });
    })(),
    owa_mm: new (class extends GraphAxis {
        unit = () => 'мм';
        options = () => ({ minTickSize: 1 });
    })(),
    owa_amper: new (class extends GraphAxis {
        unit = () => 'А';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_k_watt: new (class extends GraphAxis {
        unit = () => 'кВт';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_watt: new (class extends GraphAxis {
        unit = () => 'Вт';
        options = () => ({ minTickSize: 1 });
    })(),
    owa_herz: new (class extends GraphAxis {
        unit = () => 'Гц';
        options = () => ({ minTickSize: 1 });
    })(),
    owa_wind_m_s: new (class extends GraphAxis {
        unit = () => 'м/с';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_wind_rumb: new (class extends GraphAxis {
        format_value = (val) => rumbs[~~val] ?? '?';
    })(),
    owa_wind_azimuth: new (class extends GraphAxis {
        unit = () => '°';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_bar: new (class extends GraphAxis {
        unit = () => 'бар';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_mmrtst: new (class extends GraphAxis {
        unit = () => 'мм.рт.ст.';
        options = () => ({ minTickSize: 1 });
    })(),
    owa_kpa: new (class extends GraphAxis {
        unit = () => 'кПа';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_gpa: new (class extends GraphAxis {
        unit = () => 'гПа';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_temp_f: new (class extends GraphAxis {
        unit = () => '°F';
        options = () => ({ minTickSize: 1 });
    })(),
    owa_temp_k: new (class extends GraphAxis {
        unit = () => 'K';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_luks: new (class extends GraphAxis {
        unit = () => 'люкс';
    })(),
    owa_co: new (class extends GraphAxis {
        unit = () => 'ppm CO';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_co2: new (class extends GraphAxis {
        unit = () => 'ppm CO₂';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_lpg: new (class extends GraphAxis {
        unit = () => 'ppm LPG';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_ppm: new (class extends GraphAxis {
        unit = () => 'ppm';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_onoff: new (class extends GraphAxis {
        format_value = (val) => (val !== 0 ? 'вкл' : 'выкл');
    })(),
    owa_bin: new (class extends GraphAxis {
        format_value = (val) => pad0(val.toString(2), 8);
    })(),
    owa_hex: new (class extends GraphAxis {
        format_value = (val) => `${pad0(val.toString(16).toUpperCase(), 2)}h`;
    })(),
    owa_sec: new (class extends GraphAxis {
        unit = () => 'сек';
        options = () => ({ minTickSize: 1 });
    })(),
    owa_min: new (class extends GraphAxis {
        unit = () => 'мин';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_hour: new (class extends GraphAxis {
        unit = () => 'час';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_m3: new (class extends GraphAxis {
        unit = () => 'м³';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_l: new (class extends GraphAxis {
        unit = () => 'л';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_kg: new (class extends GraphAxis {
        unit = () => 'кг';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_cm: new (class extends GraphAxis {
        unit = () => 'см';
        options = () => ({ minTickSize: 0.1 });
    })(),
    owa_dimensionless: new (class extends GraphAxis {
    })(),
};
const unit2axis = {
    0x04: 'owa_dc_voltage',
    0x05: 'owa_ac_voltage',
    0x08: 'percent',
    0x09: 'owa_g_m3',
    0x0a: 'owa_mm',
    0x0c: 'owa_amper',
    0x0d: 'owa_k_watt',
    0x0e: 'owa_watt',
    0x0f: 'owa_herz',
    0x10: 'owa_wind_m_s',
    0x11: 'owa_wind_rumb',
    0x12: 'owa_wind_azimuth',
    0x14: 'owa_bar',
    0x15: 'owa_mmrtst',
    0x16: 'owa_kpa',
    0x17: 'owa_gpa',
    0x18: 'temperature',
    0x19: 'owa_temp_f',
    0x1a: 'owa_temp_k',
    0x1b: 'owa_luks',
    0x1c: 'owa_co',
    0x1d: 'owa_co2',
    0x1e: 'owa_lpg',
    0x1f: 'owa_ppm',
    0x20: 'owa_onoff',
    0x21: 'owa_bin',
    0x22: 'owa_hex',
    0x24: 'owa_sec',
    0x25: 'owa_min',
    0x26: 'owa_hour',
    0x27: 'owa_m3',
    0x28: 'owa_l',
    0x29: 'owa_kg',
    0x2a: 'owa_cm',
};
export function owaAxis(serial) {
    const unit_code = getOwaUnitCode(serial);
    if (unit_code == null) {
        return null;
    }
    return unit2axis[unit_code >> 2] ?? 'owa_dimensionless';
}
